module.exports = __webpack_public_path__ + "static/media/result-4.ac74293f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/result-4.png
// module id = 146
// module chunks = 0